import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Analytics } from "@vercel/analytics/react";
import { Header } from "./components/Header";
import LoadingSpinner from "./components/LoadingSpinner";

// Lazy load pages
const HomePage = lazy(() =>
  import("./pages/HomePage").then((module) => ({ default: module.HomePage }))
);
const ServicesPage = lazy(() =>
  import("./pages/ServicesPage").then((module) => ({
    default: module.ServicesPage,
  }))
);
const AboutPage = lazy(() =>
  import("./pages/AboutPage").then((module) => ({ default: module.AboutPage }))
);
const TeamPage = lazy(() =>
  import("./pages/TeamPage").then((module) => ({ default: module.TeamPage }))
);
const GalleryPage = lazy(() =>
  import("./pages/GalleryPage").then((module) => ({
    default: module.GalleryPage,
  }))
);
const ContactPage = lazy(() =>
  import("./pages/ContactPage").then((module) => ({
    default: module.ContactPage,
  }))
);
const Footer = lazy(() =>
  import("./components/Footer").then((module) => ({ default: module.Footer }))
);

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Helmet>
        <html lang="tr" />
        <title>
          Saloon Fenomen | Premium Berber Dükkanı - Bağcılar İstanbul
        </title>
        <meta
          name="description"
          content="Saloon Fenomen - Bağcılar'ın en prestijli erkek kuaförü. Profesyonel saç kesimi, sakal tasarımı ve bakım hizmetleri."
        />
      </Helmet>

      <a href="#main-content" className="skip-to-main">
        Ana içeriğe geç
      </a>

      <div className="min-h-screen bg-primary-dark font-body text-neutral-light">
        <Header />
        <main id="main-content">
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
            <Footer />
          </Suspense>
        </main>
      </div>
      <Analytics />
    </BrowserRouter>
  );
};

export default App;
